var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14C13.3125 14 14 13.3438 14 12.5V1.5C14 0.6875 13.3125 0 12.5 0H1.5C0.65625 0 0 0.6875 0 1.5V12.5C0 13.3438 0.65625 14 1.5 14H12.5ZM6.09375 10.9375C5.90625 11.1562 5.5625 11.1562 5.375 10.9375L2.125 7.6875C1.9375 7.5 1.9375 7.1875 2.125 7L2.84375 6.28125C3.03125 6.09375 3.34375 6.09375 3.53125 6.28125L5.75 8.46875L10.4375 3.78125C10.625 3.59375 10.9375 3.59375 11.125 3.78125L11.8438 4.5C12.0312 4.6875 12.0312 5 11.8438 5.1875L6.09375 10.9375Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxCheck);
export default __webpack_public_path__ + "static/media/box-check.f06e93c64be54535c9854e733bb49e9c.svg";
export { ForwardRef as ReactComponent };